import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { OrganizerType } from "../types/organizer";

interface Props {
	label: string;
	name: string;
	required?: boolean;
}

const options = Object.values(OrganizerType);

export const OrganizerTypeSingleSelectField: FC<Props> = ({ label, name, required }) => {
	const { t } = useTranslation();
	return (
		<SingleSelectField
			label={label}
			name={name}
			getLabel={(type) => t(type)}
			clearable={false}
			options={options}
			required={required}
		/>
	);
};
